// src/components/SubscribeForm.js
import React, { useState } from 'react';
import RapidLogo from '../assets/rapid.png';

const SubscribeForm = () => {
    const [showPopup, setShowPopup] = useState(false);

    // Function to handle form submission
    const handleSubscribeClick = (e) => {
        e.preventDefault();
        setShowPopup(true); // Show the popup when the button is clicked
    };

    // Function to close the popup
    const closePopup = () => {
        setShowPopup(false);
    };

    return (
        <div className="flex flex-col items-center justify-center p-4 sm:p-8 w-full max-w-lg space-y-6 sm:space-y-8">
            {/* Logo above the title with smaller size on mobile only */}
            <div className="flex justify-center mb-4">
                <img src={RapidLogo} alt="Rapid Logo" className="w-36 sm:w-54 h-auto" />
            </div>

            {/* Title and Description outside of the box */}
            <div className="text-center space-y-4">
                <h1 className="text-xl sm:text-2xl font-bold text-white">Empower Your Trading with AI Automation</h1>
                <h2 className="text-base sm:text-lg font-light text-gray-300">
                    Our advanced bot offers <span className="font-semibold text-white">automated liquidity farming</span>, <span className="font-semibold text-white">scalping for profits</span>, and <span className="font-semibold text-white">stealthy coin launches</span>.
                    <br />
                    <br />
                    <strong>Get early access:</strong> Subscribe to secure your spot in the future of AI-driven trading.
                </h2>
            </div>

            {/* Subscription Form inside the box */}
            <div className="p-6 sm:p-8 bg-black text-white rounded-lg shadow-lg w-full border border-white">
                <form className="flex flex-col space-y-4" onSubmit={handleSubscribeClick}>
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Enter your Telegram handle"
                            required
                            className="w-full bg-transparent text-gray-200 border-b border-gray-700 focus:border-white outline-none focus:ring-0 transition duration-200 placeholder-gray-500"
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full p-2 bg-white text-black font-semibold rounded-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-white uppercase text-center"
                    >
                        Subscribe
                    </button>
                </form>
            </div>

            {/* Popup Modal */}
            {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-4 w-80 text-center shadow-lg">
                        <h3 className="text-lg font-semibold mb-2">Submissions are Closed</h3>
                        <p className="text-sm text-gray-700">Waitlist is full. Please check back later.</p>
                        <button
                            onClick={closePopup}
                            className="mt-4 bg-gray-800 text-white px-4 py-2 rounded-md hover:bg-gray-700"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscribeForm;
